import z from "zod";

import { Coupon } from "@/shared/domains/coupons";
import { BILLING_FREQUENCY } from "@/shared/domains/subscriptions";
import { CATEGORY_SLUG, PRICE_TAG_TYPE, PRICE_TYPE } from "./enums";

export const Category = z.object({
  id: z.number(),
  slug: z.enum(CATEGORY_SLUG),
  name: z.string(),
  description: z.string().optional(),
  treatments: z.array(z.string()),
  isNew: z.boolean(),
  thumbnail: z.url().nullish(),
});
export type Category = z.infer<typeof Category>;

const Tag = z.object({
  label: z.string(),
  type: z.enum(PRICE_TAG_TYPE),
});

export const Price = z.object({
  id: z.number(),
  get durationInMonths() {
    return z.enum(BILLING_FREQUENCY);
  },
  subscriptionPriceId: z.string(),
  price: z.number(),
  tags: z.array(Tag),
  dose: z.string().optional(),
  isSubscribed: z.boolean(),
  type: z.enum(PRICE_TYPE),
  // TODO: check if value is null or just optional
  get discount() {
    return Coupon.nullable().optional();
  },
});
export type Price = z.infer<typeof Price>;

export const Product = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().optional(),
  features: z.string(),
  disclaimer: z.string(),
  thumbnail: z.url().nullable(),
  category: Category.pick({ id: true, name: true, slug: true }),
  prices: z.array(Price),
  slug: z.string(),
  tags: Price.shape.tags,
  priceTag: z.string().optional(),
});
export type Product = z.infer<typeof Product>;
